import {Injectable} from "@angular/core";
import {CheckTokenStatusService} from "../tokenstatus/check-token-status.service";
import {SystemAuthenticationService} from "@monex-sistemas/nueva-banca-digital-library";
import {ToastService} from "../toast/toast.service";

@Injectable({providedIn: "root"})
export class ValidateRsaTokenService {

    constructor(private tokenStatusService: CheckTokenStatusService,
                private systemAuthService: SystemAuthenticationService,
                private toastService: ToastService) {
    }


    async validateRsaToken(tokenStatusTranslations, pubSubData){
        let tokenStatus
        this.systemAuthService.showLoading()
        try {
            tokenStatus = await this.tokenStatusService.checkTokenStatus(tokenStatusTranslations, pubSubData.modalRef)
            this.systemAuthService.hideLoading();
            return tokenStatus;
        } catch (error) {
            console.log(error)
            this.toastService.showToast()
            this.systemAuthService.hideLoading()
            return
        }
    }
}
